import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import {
  matchValidator,
  patternValidator,
} from '../../../shared/helper/validators';
import { AUTH_CONFIG } from '../../config/auth-config';
import { IAuthService } from '../../services/iauth.service';
import { ContainerManagerLoginComponent } from '../container-manager-login/container-manager-login.component';

@Component({
  selector: 'app-confirmar-reset-senha',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ToastModule,
    ProgressSpinnerModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    ContainerManagerLoginComponent,
  ],
  templateUrl: './confirmar-reset-senha.component.html',
  styleUrls: ['./confirmar-reset-senha.component.scss'],
})
export class ConfirmarResetSenhaComponent implements OnInit {
  private authService = inject(IAuthService);
  private fb = inject(FormBuilder);
  private mensagemService = inject(MessageService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private config = inject(AUTH_CONFIG);

  form = this.criarForm();
  loadding = false;
  token?: string;
  email?: string;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const { token, email } = params;
      this.token = token;
      this.email = email;
    });
  }

  onSubmit() {
    if (!this.email) {
      this.mensagemService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Email não informado!',
      });
      return;
    }

    if (!this.token) {
      this.mensagemService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Token não informado!',
      });
      return;
    }

    if (this.form.invalid) return;

    this.loadding = true;
    this.form.disable();

    this.authService
      .resetarSenha(this.email, this.form.value.senha!, this.token)
      .subscribe({
        next: () => {
          this.mensagemService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Atualização de senha realizada com sucesso!',
          });
          const loginRoute = this.config.routes?.loginRoute || 'login';
          this.router.navigate(['/', loginRoute]);
        },
      })
      .add(() => {
        this.loadding = false;
        this.form.enable();
      });
  }

  private criarForm() {
    return this.fb.group(
      {
        senha: new FormControl<string>('', {
          validators: Validators.compose([
            Validators.required,
            Validators.minLength(8),
            patternValidator(new RegExp('(?=.*[0-9])'), {
              requiresDigit: true,
            }),
            patternValidator(new RegExp('(?=.*[A-Z])'), {
              requiresUppercase: true,
            }),
            patternValidator(new RegExp('(?=.*[a-z])'), {
              requiresLowercase: true,
            }),
            patternValidator(new RegExp('(?=.*[$@^!%*?&])'), {
              requiresSpecialChars: true,
            }),
          ]),
          nonNullable: true,
        }),
        confirmarSenha: new FormControl<string>('', {
          validators: [Validators.required],
          nonNullable: true,
        }),
      },
      {
        validators: matchValidator('senha', 'confirmarSenha'),
      }
    );
  }

  get senha() {
    return this.form.get('senha');
  }

  get confirmarSenha() {
    return this.form.get('confirmarSenha');
  }
}
